<div class="tp-dropdown">
  <mat-form-field floatLabel="never">
    <mat-label>
      <span
        class="tp-dropdown__label-text"
        [class.tp-dropdown__label-text--active]="selectRef.panelOpen"
        [class.tp-dropdown__label-text--semi-transparent]="placeholderOpacity"
        >{{ options?.length ? placeholder : 'No Options Available' }}</span
      >
    </mat-label>

    <div class="tp-dropdown__double-arrow">
      <tp-icon name="icons/double-arrow"></tp-icon>
    </div>

    <mat-select
      [multiple]="multiple"
      [disableOptionCentering]="true"
      [value]="selectedOption"
      #selectRef
      class="tp-dropdown__visible-option"
      [class.tp-dropdown__visible-option--opened]="selectRef.panelOpen"
      panelClass="tp-dropdown__multiple-panel"
      (selectionChange)="onSelectionChange($event)"
      (openedChange)="onOpenChanged($event)"
      [tabIndex]="tabIndex || 0"
      [disabled]="isDisabled"
    >
      <ng-container *ngIf="grouped">
        <mat-optgroup *ngFor="let group of options" [label]="group.label">
          <mat-option
            *ngFor="let option of group.options"
            class="tp-dropdown__option"
            [value]="emitOptionValue ? option.value : option"
            [class.tp-dropdown__option--disabled]="option.isDisabled"
            [disabled]="option.isDisabled"
          >
            {{ option.text }}
          </mat-option>
        </mat-optgroup>
      </ng-container>

      <ng-container *ngIf="!grouped">
        <mat-option
          *ngFor="let option of options"
          class="tp-dropdown__option"
          [value]="emitOptionValue ? option.value : option"
          [class.tp-dropdown__option--disabled]="option.isDisabled"
          [disabled]="option.isDisabled"
        >
          {{ option.text }}
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
</div>
